
import {type FUNDING_SOURCE, type PayPalButtonsComponentOptions} from '@paypal/paypal-js';
import {FeatureFlag} from '../../../@type/features';
import {Feature} from '../features';
import {AbstractPayPalPayment} from './abstract/class-abstract-paypal-payment';

class PayPalWalletPayment extends AbstractPayPalPayment {
	public gatewayId() {
		return 'peachpay_paypal_wallet';
	}

	protected fundingType(): FUNDING_SOURCE {
		return 'paypal';
	}

	protected buttonStyle() {
		return Feature.metadata<PayPalButtonsComponentOptions['style']>(FeatureFlag.PAYPAL_WALLET_GATEWAY, 'button_style') ?? undefined;
	}
}

export {PayPalWalletPayment};
